import { render, staticRenderFns } from "./DisplayGradeInfo.vue?vue&type=template&id=61acd568&scoped=true&"
import script from "./DisplayGradeInfo.vue?vue&type=script&lang=ts&"
export * from "./DisplayGradeInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61acd568",
  null
  
)

export default component.exports